// extracted by mini-css-extract-plugin
export var brand = "_45-9";
export var compact = "_45-6";
export var extraSmall = "_45-7";
export var icon = "_45-0";
export var large = "_45-4";
export var light = "_45-1";
export var medium = "_45-5";
export var outline = "_45-b";
export var primaryDark = "_45-a";
export var primaryLight = "_45-8";
export var primaryModern = "_45-c";
export var success = "_45-2";
export var successSolid = "_45-3";